import React, { useState } from "react";
import Project from "components/Project";

import { createStyles, Container, Stack, Space } from "@mantine/core";
import { ProjectType } from "./Project";

const useStyles = createStyles(() => ({
  big: {
    padding: "5px 15px",
    textAlign: "center",
    fontSize: "36px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "bolder",
    marginTop: "40px",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "100px",
  },
  interest: {
    display: "flex",
    justifyContent: "center",
    width: "100%",

    "&:hover": {
      cursor: "pointer",
      color: "#FDD9B5",
    },
  },
}));

const Projects = () => {
  const { classes } = useStyles();
  const [open, setOpen] = useState<number[]>([]);
  const projects: ProjectType[] = [
    {
      id: 5,
      title: "Sagetap v2",
      desc: "A new and improved version of Sagetap's platform",
      details: "Sagetap v2 is an in progress project where we are completely rebuilding our product from scratch using new technologies, designs, and features to give our users a faster and smoother experience.\n\nPersonal contributions so far include: client profile creation and editing, an autonomous session scheduling flow, the entire settings portal, user reviews and opt-ins, user history and session tables, and many base UI components.",
      tools: "React | TypeScript | Next.js | Kotlin | React Query | React Hook Form | React Testing Library | Storybook | Rest APIs",
      img: "sagetapv2"
    },
    {
      id: 4,
      title: "Highlights",
      desc: "Highlighting system for clients to organize and spotlight key data",
      details:
        "Highlights is a feature built to give Sagetap's clients a method to save and showcase data and dialog from their calls with our expert network. I implemented a clean, new UI that displays the expert's information, the clip's transcript, and a play bar to play the clip's audio.\n\nAdditional functionalities I created include: read more/show more text, click to view transcript, viewing the expert's profile, editing the highlight, downloading the highlight, sharing the highlight/making a public highlight for non-Sagetap members, displaying the expert's KPI's, and auto-playing the clips.",
      tools: "React | TypeScript | MUI | Rest APIs",
      img: "highlights",
    },
    {
      id: 1,
      title: "Lost but Found",
      desc: "Categorical index for NYC's lost and found system",
      details:
        "This is a fully-responsive web app that displays and categorizes the lost and found items of New York City's MTA system in hopes of helping people track their belongings and contacting the proper MTA authorities to facilitate recoveries. The local news and weather are also displayed.",
      tools: "React | JavaScript | Node.js | Express | Rest APIs | Heroku",
      img: "lbf",
      git: "https://github.com/benjaminho1998/lost-but-found-MTA",
    },
    {
      id: 2,
      title: "Spellbound",
      desc: "Voice interactive spelling app",
      details:
        'Spellbound was a group project for my Intro to HCI class. We ideated, prototyped, and partially-developed this app to help children learn in a fun and engaging way. The primary function was the voice interactive spelling which we achieved through "Wizard of Oz" techniques.\n\nWe competed with 40+ other teams at the 2018 Stanford HCI Expo where we won Best Concept and Best Overall App.',
      tools: "HTML | CSS | Figma | UX/UI",
      img: "spellbound",
      link: "https://xd.adobe.com/view/8631cd26-8ff7-4633-746a-0fd5e9622385-f000/",
    },
    {
      id: 3,
      title: "Weather Forecast",
      desc: "Weather forecasts for anywhere in the world",
      details:
        "The weather app takes in any location in the world and outputs the area's 10 day weather forecast. I used 3rd party REST API's such as OpenWeather to support location lookup, and to gather weather data for the inputted area.",
      tools: "React | JavaScript | Rest APIs",
      img: "weather",
    },
  ];

  return (
    <Container id="projects" size="xl">
      <div className={classes.sectionHeader}>
        <span className={classes.big}>Projects</span>
      </div>
      <Stack spacing={100}>
        {projects.map((project) => (
          <div key={project.id}>
            <Project project={project} open={open} setOpen={setOpen} />
          </div>
        ))}
      </Stack>
      <Space h={175} />
      <h1
        className={classes.interest}
        onClick={(e) => {
          e.preventDefault();
          const element = document.getElementById("contact");
          element &&
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }}
      >
        Interested?
      </h1>
      <Space h={75} />
    </Container>
  );
};

export default Projects;
